import React from "react";
import {
  FOOTER_LINKS,
  HEADER_LINKS,
  SERVICE_PAGE_SERVICES,
} from "../../constants";
import ScrollToTop from "../../components/ScrollToTop";
import { TitleTag } from "../../components/TitleTag";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BreadCrumb from "../../components/BreadCrumb";
import breadcrumbImage from "../../images/service/smile.webp";
import Services from "../../components/Services";

export const ServicePage = () => {
  return (
    <>
      <ScrollToTop />
      <TitleTag pageTitle="Services" />
      <Header dropDownLinks={HEADER_LINKS} />{" "}
      <BreadCrumb
        title="Services"
        text="What we offer "
        bgImage={breadcrumbImage}
      />
      <Services services={SERVICE_PAGE_SERVICES} />
      <Footer footerLinks={FOOTER_LINKS} />
    </>
  );
};
